import "../../../App.css";
import "./AddAccount.css";

import { useState } from "react";
import {
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import {
    Alert,
    Button,
    Form,
    Input,
    InputNumber,
    Select,
    notification,
} from "antd";
import axios from "axios";
import moment from "moment";

import Appconfig from "../../../config/config";

/*
 * Change this value whenever you want to change
 * the valid transaction password.
 */
const CORRECT_TRANSACTION_PASSWORD = "123";

const AddAccount = () => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] =
        useState(false);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const getLoggedInUser = () => {
        try {
            const storedUserData =
                localStorage.getItem("userdata");

            return storedUserData
                ? JSON.parse(storedUserData)
                : {};
        } catch (error) {
            console.error(
                "Unable to read user data from localStorage:",
                error
            );

            return {};
        }
    };

    const userInfo = getLoggedInUser();

    const masterId =
        searchParams.get("master_id") ||
        userInfo?._id ||
        "";

    const requestedReturnPath =
        searchParams.get("return_to") ||
        "/clients";

    const returnTo =
        requestedReturnPath.startsWith("/")
            ? requestedReturnPath
            : "/clients";

    const accountTypes = [
        {
            label: "Master",
            value: "Master",
        },
        {
            label: "User",
            value: "User",
        },
    ];

    const safelyGoBack = () => {
        navigate(returnTo);
    };

    const handleSubmit = async (values) => {
        if (!masterId) {
            notification.error({
                message: "Parent Master ID Missing",
                description:
                    "A parent master ID is required to create an account.",
                placement: "topRight",
                duration: 4,
            });

            return;
        }

        const enteredTransactionPassword =
            String(
                values.transaction_password || ""
            ).trim();

        if (
            enteredTransactionPassword !==
            CORRECT_TRANSACTION_PASSWORD
        ) {
            notification.error({
                message:
                    "Incorrect Transaction Password",
                description:
                    "The transaction password you entered is incorrect.",
                placement: "topRight",
                duration: 4,
            });

            form.setFields([
                {
                    name: "transaction_password",
                    errors: [
                        "The transaction password is incorrect.",
                    ],
                },
            ]);

            return;
        }

        if (!Appconfig?.apiUrl) {
            notification.error({
                message:
                    "API Configuration Missing",
                description:
                    "The API URL is not configured. Please check the application configuration.",
                placement: "topRight",
                duration: 4,
            });

            return;
        }

        setSubmitting(true);

        const payload = {
            master_id: masterId,

            registration_date:
                moment().format("YYYY-MM-DD"),

            site_code:
                Appconfig?.sitecodes || "",

            user_name:
                values.user_name?.trim() || "",

            user_type:
                values.user_type || "User",

            password:
                values.password || "",

            opening_balance:
                Number(
                    values.opening_balance || 0
                ),

            credit_limit:
                Number(values.credit_limit || 0),

            exposer_limit:
                Number(values.exposer_limit || 0),

            name:
                values.full_name?.trim() || "",

            city:
                values.city?.trim() || "",

            phone:
                values.phone?.trim() || "",

            transaction_password:
                enteredTransactionPassword,

            commission:
                Number(values.commission || 0),

            partnership:
                Number(
                    values.partnership ?? 100
                ),

            rolling_commission: "No",
            agent_rolling_commission: "No",

            rolling_commission_binary: 0,
            rolling_commission_bookmaker: 0,
            rolling_commission_casino: 0,
            rolling_commission_fancy: 0,
            rolling_commission_matka: 0,
            rolling_commission_sportbook: 0,
            rolling_commission_virtualsport: 0,
        };

        try {
            const response = await axios.post(
                `${Appconfig.apiUrl}users/addDaddyUser`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            if (response?.data?.result) {
                notification.success({
                    message:
                        "Account Created Successfully",
                    description:
                        "The new account has been created successfully.",
                    placement: "topRight",
                    duration: 4,
                });

                form.resetFields();
                navigate(returnTo);

                return;
            }

            notification.error({
                message:
                    "Unable to Create Account",
                description:
                    response?.data?.message ||
                    response?.data?.resultData
                        ?.message ||
                    "The account could not be created. Please try again.",
                placement: "topRight",
                duration: 4,
            });
        } catch (error) {
            console.error(
                "Add account API error:",
                error
            );

            notification.error({
                message:
                    "Unable to Create Account",
                description:
                    error?.response?.data
                        ?.message ||
                    error?.response?.data
                        ?.resultData?.message ||
                    error?.message ||
                    "A server error occurred while creating the account.",
                placement: "topRight",
                duration: 4,
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <main className="add-account-page">
            <section className="add-account-card">
                <div className="add-account-heading-row">
                    <div>
                        <h1>Add Account</h1>

                        {/* <p>
                            Create a new master or user
                            account
                        </p> */}
                    </div>

                    <Button
                        type="default"
                        className="add-account-back-button"
                        onClick={safelyGoBack}
                    >
                        Back to Account List
                    </Button>
                </div>

                {!masterId && (
                    <Alert
                        type="error"
                        showIcon
                        className="add-account-error-alert"
                        message="Parent Master ID Missing"
                        description="Return to the Account List and click the Add Account button again."
                        action={
                            <Button
                                size="small"
                                type="primary"
                                onClick={() =>
                                    navigate(
                                        "/clients"
                                    )
                                }
                            >
                                Account List
                            </Button>
                        }
                    />
                )}

                <Form
                    form={form}
                    layout="vertical"
                    requiredMark
                    disabled={submitting}
                    onFinish={handleSubmit}
                    initialValues={{
                        user_type: "User",
                        opening_balance: 0,
                        credit_limit: 0,
                        exposer_limit: 0,
                        commission: 0,
                        partnership: 100,
                    }}
                >
                    <div className="add-account-top-grid">
                        <section className="add-account-section">
                            <h2 className="add-account-section-title">
                                Personal Details
                            </h2>

                            <div className="add-account-fields-grid">
                                <Form.Item
                                    label="Client Name"
                                    name="user_name"
                                    normalize={(value) =>
                                        value?.trimStart()
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please enter the client name.",
                                        },
                                        {
                                            whitespace: true,
                                            message:
                                                "Please enter a valid client name.",
                                        },
                                    ]}
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="Client Name"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="User Password"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please enter a password.",
                                        },
                                        {
                                            min: 6,
                                            message:
                                                "The password must contain at least 6 characters.",
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        autoComplete="new-password"
                                        placeholder="Password"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Retype Password"
                                    name="confirm_password"
                                    dependencies={[
                                        "password",
                                    ]}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please re-enter the password.",
                                        },
                                        ({
                                            getFieldValue,
                                        }) => ({
                                            validator(
                                                _,
                                                value
                                            ) {
                                                if (
                                                    !value ||
                                                    getFieldValue(
                                                        "password"
                                                    ) ===
                                                        value
                                                ) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(
                                                    new Error(
                                                        "Both passwords must match."
                                                    )
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        autoComplete="new-password"
                                        placeholder="Retype Password"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Full Name"
                                    name="full_name"
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="Full Name"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="City"
                                    name="city"
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="City"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Phone"
                                    name="phone"
                                    rules={[
                                        {
                                            pattern:
                                                /^[0-9+\-\s]{7,18}$/,
                                            message:
                                                "Please enter a valid phone number.",
                                        },
                                    ]}
                                >
                                    <Input
                                        autoComplete="off"
                                        inputMode="tel"
                                        placeholder="Phone Number"
                                    />
                                </Form.Item>
                            </div>
                        </section>

                        <section className="add-account-section">
                            <h2 className="add-account-section-title">
                                Account Details
                            </h2>

                            <div className="add-account-fields-grid">
                                <Form.Item
                                    label="Account Type"
                                    name="user_type"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please select an account type.",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select Account Type"
                                        options={
                                            accountTypes
                                        }
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Credit Reference"
                                    name="credit_limit"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please enter the credit reference.",
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        min={0}
                                        precision={2}
                                        controls={false}
                                        placeholder="Credit Reference"
                                        className="add-account-number-input"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Opening Balance"
                                    name="opening_balance"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please enter the opening balance.",
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        min={0}
                                        precision={2}
                                        controls={false}
                                        placeholder="Opening Balance"
                                        className="add-account-number-input"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Exposure Limit"
                                    name="exposer_limit"
                                >
                                    <InputNumber
                                        min={0}
                                        precision={2}
                                        controls={false}
                                        placeholder="Exposure Limit"
                                        className="add-account-number-input"
                                    />
                                </Form.Item>
                            </div>
                        </section>
                    </div>

                    <section className="add-account-setting-section">
                        <h2 className="add-account-section-title">
                            Commission Settings
                        </h2>

                        <div className="add-account-setting-table">
                            <div className="add-account-setting-row">
                                <span>Upline</span>
                                <strong>0</strong>
                            </div>

                            <div className="add-account-setting-row">
                                <span>Downline</span>

                                <Form.Item
                                    name="commission"
                                    noStyle
                                >
                                    <InputNumber
                                        min={0}
                                        max={100}
                                        precision={2}
                                        controls={false}
                                        className="add-account-number-input"
                                    />
                                </Form.Item>
                            </div>

                            <div className="add-account-setting-row">
                                <span>Our</span>
                                <strong>100</strong>
                            </div>
                        </div>
                    </section>

                    <section className="add-account-setting-section">
                        <h2 className="add-account-section-title">
                            Partnership
                        </h2>

                        <div className="add-account-setting-table">
                            <div className="add-account-setting-row">
                                <span>Upline</span>
                                <strong>0</strong>
                            </div>

                            <div className="add-account-setting-row">
                                <span>Downline</span>

                                <Form.Item
                                    name="partnership"
                                    noStyle
                                >
                                    <InputNumber
                                        min={0}
                                        max={100}
                                        precision={2}
                                        controls={false}
                                        className="add-account-number-input"
                                    />
                                </Form.Item>
                            </div>

                            <div className="add-account-setting-row">
                                <span>Our</span>
                                <strong>0</strong>
                            </div>
                        </div>
                    </section>

                    <div className="add-account-transaction-area">
                        <Form.Item
                            label="Transaction Password"
                            name="transaction_password"
                            className="add-account-transaction-password"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        "Please enter the transaction password.",
                                },
                            ]}
                        >
                            <Input.Password
                                placeholder="Transaction Password"
                                autoComplete="new-password"
                                visibilityToggle={
                                    false
                                }
                                onChange={() => {
                                    const errors =
                                        form.getFieldError(
                                            "transaction_password"
                                        );

                                    if (
                                        errors.length
                                    ) {
                                        form.setFields([
                                            {
                                                name: "transaction_password",
                                                errors: [],
                                            },
                                        ]);
                                    }
                                }}
                            />
                        </Form.Item>

                        <div className="add-account-create-row">
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={
                                    submitting
                                }
                                disabled={
                                    !masterId ||
                                    submitting
                                }
                                className="add-account-create-button"
                            >
                                Create Account
                            </Button>
                        </div>
                    </div>
                </Form>
            </section>
        </main>
    );
};

export default AddAccount;